import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Modal } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import IBaseComponent from './Interfaces/Base/IBaseComponent';
import ISection from './Interfaces/ISection';
import FormflowContext from './Util/FormflowContext';
import TaskIconDictionary from './Util/TaskIconDictionary';

const confirm = Modal.confirm;
interface ITaskComponentProps {
  component: IBaseComponent,
  section: ISection,
  index: number
}

interface ITaskComponentState {
  isComponentModalOpen: boolean;
}

export default class TaskComponent extends React.Component<ITaskComponentProps, ITaskComponentState> {

  constructor(props: ITaskComponentProps) {
    super(props);

    this.state = {
      isComponentModalOpen: false
    };
  }

  showDeleteConfirm(onDelete: Function) {
    confirm({
      title: I18n.l("formflow.labels.titleRemoveComponent"),
      content: I18n.l("formflow.labels.removeComponent"),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    return (
      <FormflowContext.Consumer>
        {({ setCurrentComponent, removeComponentFromFormflow }) => (
          <CardContentStyle>
            <React.Fragment>

              <div key={this.props.index} className={this.props.component === undefined ? "item-container" : "item-container-with-content"}>
                <DraggableCardContentWrapper>
                  <div className='icon-wrapper'>
                    <FontAwesomeIcon icon={'grip-horizontal'} />
                  </div>
                  <div>
                    <span className={'item-container-number'} >{this.props.index + 1 + ' '}</span>
                    {TaskIconDictionary !== null &&
                      <FontAwesomeIcon className="item-icon-container" icon={TaskIconDictionary.get(this.props.component.type) as IconProp} />
                    }
                    <span className={"item-container-font-style"}>
                      {this.props.component.required === true && <span style={{ color: 'red' }} > *</span>}
                      {this.props.component.id === '' ? 'nenhum' : ' ' + this.props.component.title}
                      {this.props.component.required === true && <span style={{ color: ` ${Theme.secondary.darkGrey}` }} > ({I18n.l("formflow.labels.required")})</span>}
                      <ButtonStyle>
                        <Button onClick={() => { setCurrentComponent(this.props.component, this.props.section) }} style={{ marginLeft: '-90px', height: '2rem', fontWeight: 'normal' }} type="primary" ghost>
                          {I18n.l("common.edit")}
                        </Button>
                        <span style={{ color: `${Theme.secondary.midGrey}` }} >|</span>
                        <Button disabled={this.props.component.type === ComponentType.MATRIX ? true : false} onClick={() => this.showDeleteConfirm(() => removeComponentFromFormflow(this.props.component, this.props.section))} style={{ border: '0px', height: '2rem', fontWeight: 'normal' }} type="danger" ghost>
                          {I18n.l("common.delete")}
                        </Button>
                      </ButtonStyle>
                    </span>
                  </div>
                </DraggableCardContentWrapper>
              </div>
            </React.Fragment>
          </CardContentStyle>
        )}

      </FormflowContext.Consumer>
    )
  }
}

const ButtonStyle = styled.div`
    height: 2rem;
    width: 80px; 
    float: right;
    margin-top: 20px;
    font-weight: normal;

`
const CardContentStyle = styled.li`
    width: 100%;
    padding-top: 25px;
    padding-right: 25px;
    
    .item-container{
        cursor:pointer;
        flex: 1;
        height: 70px;
        background-color: ${Theme.secondary.supahLightGrey};
        border: 1px solid ${Theme.secondary.midLightGrey};
        margin-bottom: 10px;
        border-radius: 5px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        text-align: center;
        padding-top: 1.6rem;
    }

    .item-container-number{
      
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        font-size: 24px;
        line-height: 70px;
    }

    .item-container-with-content{
        cursor:grab;
        height: 95px;
        background-color: ${Theme.secondary.supahLightGrey};
        border: 1px solid ${Theme.secondary.midLightGrey};
        border-radius: 5px;
        text-align: left;
        padding: 7px 20px 10px 20px;
        &:active: {
          cursor:grabbing;
        }

    }
    .item-container-font-style{
        color: ${Theme.secondary.black};
        font-size: 12px;
        margin-left: 20px;
        margin-top: 100px;
        vertical-align: 4px;
    }

    .item-icon-container{
        vertical-align: -7px;
        color: ${Theme.secondary.darkGrey};
        padding:5px;
        height: 30px;
        width: 30px;
        margin-left: 5px;
        border-radius: 5px;
        background-color: ${Theme.secondary.lightGrey}
    }

    Button{
        width: 100%;
        height: 5rem;
        background: ${Theme.secondary.supahLightGrey};
        border-color: ${Theme.secondary.lightGrey};
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        :hover {
            width: 100%;
            height: 5rem;
            background: ${Theme.secondary.supahLightGrey};
            border-color: ${Theme.secondary.lightGrey};
            font-weight: bold;
            color: ${Theme.secondary.midGrey};
        }
        :focus {
            width: 100%;
            height: 5rem;
            background: ${Theme.secondary.supahLightGrey};
            border-color: ${Theme.secondary.lightGrey};
            font-weight: bold;
            color: ${Theme.secondary.midGrey};
        }
    }
`
const DraggableCardContentWrapper = styled.div`
    display: flex;
    flex-flow: column;
    color: ${Theme.secondary.darkGrey};

    .icon-wrapper{
      display: flex;
      justify-content: center;
      align-items:center;
    }
`
